import { render, staticRenderFns } from "./MRCompleteButton.vue?vue&type=template&id=2efac4cc"
import script from "./MRCompleteButton.vue?vue&type=script&lang=ts"
export * from "./MRCompleteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports